export default "__VITE_ASSET__DS51TTZc__"